// removed by extract-text-webpack-plugin
module.exports = {"FooterLayout":"hJayBK__"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/footer/footer-layout.styles.scss
// module id = 540
// module chunks = 0